interface DynamicContext {
    hasDynamicContext: boolean;
}

export default class Preset implements DynamicContext {
    constructor(readonly name: string, readonly key: string, readonly widgetTypes: Array<string>, readonly hasDynamicContext: boolean) {}
}

export class AtomisablePreset implements DynamicContext {
    constructor(readonly name: string, readonly key: string, readonly hasDynamicContext: boolean) {}
}
